import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { exchangeGoogleSession, formatErr } from "./adminApi";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export default function AuthCallback() {
  const nav = useNavigate();
  const ran = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const session_id = m ? decodeURIComponent(m[1]) : null;
    if (!session_id) { nav("/admin/login", { replace: true }); return; }
    (async () => {
      try {
        await exchangeGoogleSession(session_id);
        window.history.replaceState(null, "", window.location.pathname + window.location.search);
        nav("/admin", { replace: true });
      } catch (err) { setError(formatErr(err)); }
    })();
  }, [nav]);

  return (
    <div className="min-h-screen bg-white text-[#0a0a0a] flex items-center justify-center px-6">
      <div className="max-w-md text-center">
        <p className="font-mono-ui text-[11px] tracking-[0.3em] uppercase text-[#C8102E] mb-4">— Signing you in</p>
        {!error ? (
          <p className="font-display text-3xl">One moment…</p>
        ) : (
          <>
            <p className="font-display text-3xl mb-6">Access denied.</p>
            <p data-testid="auth-callback-error" className="text-black/65 mb-8">{error}</p>
            <a href="/admin/login" className="inline-flex items-center gap-2 border border-black/30 hover:bg-[#0a0a0a] hover:text-white px-5 py-3 font-mono-ui text-[11px] tracking-[0.2em] uppercase transition">
              Back to sign in
            </a>
          </>
        )}
      </div>
    </div>
  );
}
